"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _dist = require("@low6dev/react-utils/dist");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 50px;\n  border-radius: 0.5rem;\n  border-top-left-radius: 2rem;\n  border-bottom-left-radius: 2rem;\n  font-size: 0.75rem;\n  background: ", ";\n  color: ", ";\n  margin: 1rem 0 1rem;\n"])), function (p) {
  return p.theme.colorSuccess;
}, function (p) {
  return p.theme.colorSuccessText;
});

var StyledTipsterWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  overflow: hidden;\n  top: 50%;\n  left: -1px;\n  transform: translateY(-50%);\n  border-radius: 50%;\n  background: #fff;\n  border: 4px solid ", ";\n"])), function (p) {
  return (0, _polished.darken)(0.0625, p.theme.colorSuccess);
});

var StyledTipster = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 54px;\n  height: 54px;\n"])));

var StyledTitle = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-left: 74px;\n  font-size: 0.875rem;\n  color: ", ";\n"])), (0, _polished.rgba)("white", 0.75));

var StyledValue = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 0 0 35%;\n  text-align: center;\n  font-size: 1.25rem;\n  line-height: 18px;\n  color: white;\n\n  @media (min-width: ", ") {\n    flex: 0 0 130px;\n  }\n"])), function (props) {
  return props.theme.screenWidthXs;
});

var ContestPicksTips = function ContestPicksTips(_ref) {
  var _tip$tipster;

  var tip = _ref.tip,
      tipsterString = _ref.tipsterString;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTipsterWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTipster, {
        style: {
          backgroundImage: "url(".concat(tip === null || tip === void 0 ? void 0 : (_tip$tipster = tip.tipster) === null || _tip$tipster === void 0 ? void 0 : _tip$tipster.avatar, ")"),
          backgroundSize: "110%",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat"
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTitle, {
      children: [tip.tipster.name, "'s Pick"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledValue, {
      children: tipsterString
    })]
  });
};

var _default = ContestPicksTips;
exports.default = _default;